import { HwTypeKey } from "@const/hwTypeKey.constants";

// const HwTypeRoutes = Object.fromEntries(Object.entries(HwTypeKey).map(([key, value]) => [key, `/${value}`])) as {
//   [K in keyof typeof HwTypeKey]: `/${typeof HwTypeKey[K]}`;
// };

// const ClassRoutes = Object.fromEntries(Object.entries(ClassKey).map(([key, value]) => [key, `/${value}`])) as {
//   [K in keyof typeof ClassKey]: `/${typeof ClassKey[K]}`;
// };

export enum RoutePath {
  CLASS = '/class',
  CUSTOM_GROUPS = '/custom',
  CUSTOM_LINKS = '/custom-links',
  DASHBOARD = '/dashboard',
  DEFAULT = '/default',
  DB = '/db',
  FOLDER = '/folder',
  GET_PATH = '/getpath',
  GROUP = '/group',
  GROUPING = '/grouping',
  HELP = '/help',
  RELOAD = '/reload',
  SERVER_GROUP = "/servergroup",
  SETTINGS = '/settings',
  SET_SG = '/sg',
  SGROUP = '/sgroup',
  TYPE = '/type',

  // top icons
  FAVORITES = '/favorites',
  GLOB_HS = '/glob-hs-summary',
  SEARCH = '/search',

  // user
  PROFILE = '/profile',
  LOGOUT = '/logout',

  // configuration
  CONFIGURATION = '/configuration',
  DEVICE = '/device',
  SET_ALIAS = '/alias',
  SET_BACKEND = '/backend',
  SET_CG = '/cg',
  SET_CONF_IMP_EXP = "/conf-imp-exp",
  SET_DASH_MANAGE = '/dm',
  SET_DEVICE = '/dev',
  SET_HEATMAP_TIERS = '/ht',
  SET_OS_AGENT = '/os_agent',
  SET_PROXY = '/proxy',
  USERMANAGEMENT = '/user_management',

  // tools
  ADVISOR = '/advisor',
  ALERTING = '/alerting',
  CMDB = '/cmdb',
  EVENTS = '/events',
  EXPORTER = '/exporter',
  OTEL = '/otel',
  PUBLIC_API = "/public_api",
  REPORTER = '/reporter',
  TAGS = '/tags',
  TOOLS = '/tools',
  TOPOLOGY = '/topology',
  TRENDS = '/trends',

  // help
  ABOUT = '/about',
  DOCUMENTATION = '/documentation',
  LICENSE = '/license',
  LOG_UI = '/ui-log',
  LOG_AUDIT = '/audit-log',
  LOG_SUPPORT = '/support-logs',
  SET_SELF_MONITORING = '/self_monitoring',
  SET_LOGS = '/logs',
  SUPPORT = '/support',
  UPGRADE = '/upgrade',

  PLAYGROUND = '/playground',

  //#region DEVICES

  // virtualization
  SERVER = '/server',
  HYPERV = '/hyperv',
  HUAWEI = '/huawei',
  LINUX = '/linux',
  MAINFRAME_CFG = '/mainframe',
  NUTANIX_CFG = '/nutanix',
  MORPHEUS_CFG = '/morpheus',
  ORACLEVM = '/oraclevm',
  OVIRT = '/ovirt',
  POWER_CFG = '/power',
  PROXMOX_CFG = '/proxmox',
  VMWARE_CFG = '/vmware',
  XEN = '/xen',

  // server SP
  SERVER_SP = '/server_sp',
  // HPEILO = '/hpeilo',
  // DIDRAC = '/didrac',
  // LXCLARITY = '/lxclarity',
  // HPEONEVIEW = '/hpeoneview',

  // cloud
  CLOUD = '/cloud',
  CLOUDSTACK_CFG = '/cloudstack',
  AZURE_CFG = '/azure',
  AMAZON_CFG = '/aws',
  GCLOUD_CFG = '/gcloud',
  IBMCLOUD_CFG = '/ibmcloud',
  SKYTAP_CFG = '/skytap',

  // container
  CONTAINER = '/container',
  DOCKER_CFG = '/docker',
  KUBERNETES_CFG = '/kubernetes',
  OPENSHIFT_CFG = '/openshift',
  TANZU_CFG = '/tanzu',

  // DB
  DATABASE = '/database',
  DB2 = '/db2',
  MONGODB = '/mongodb',
  ORACLEDB = '/oracledb',
  POSTGRES = '/postgres',
  SQLSERVER = '/sqlserver',

  STORAGES = '/storages',
  STORAGE = '/storage',

  // network
  NETWORK = '/network',

  LAN_CFG = '/lan',
  LAN_OTHERS = '/' + HwTypeKey.LANOTHERS,
  LAN_CISCO = '/' + HwTypeKey.LANCISCO,
  LAN_FIREWALL_CISCO = '/' + HwTypeKey.FIREWALLCISCO,
  LAN_JUNIPER = '/' + HwTypeKey.JUNIPER,
  LAN_FORTIGATE = '/' + HwTypeKey.FORTIGATE,

  SAN = '/san',

  // backup
  BACKUP = '/backup',

  // tape
  TAPE = '/tape',

  //#endregion

  MATCH_CMP = '/:cmp',
  MATCH_SECTION_CMP = '/:section/:cmp',
  MATCH_ALERTING = '/alerting/:section',
  MATCH_EXPORTER = '/exporter/:section',
  MATCH_REPORTER = '/reporter/:section',
  MATCH_EVENTS = '/events/:section',
  // /settings/utilities/:subtype/:group?/:item?
  MATCH_SETTINGS_HELP = '/settings/help/:subtype',
  MATCH_GROUP_ONLY = ':group',
  // /:class/device/:type/:item?
  MATCH_DEVICE = '/:class/device/:type/:item',
  // /:class/type/:type/:item?
  MATCH_TYPE = '/:class/type/:type/:item',
  // /:class/group/:group/:type?/:item?
  MATCH_GROUP_TOP = '/:class/group/:group/:type',
  MATCH_ITEM_ONLY = ':item',
  MATCH_CLASS_TYPE_ITEM = '/:class/:type/:item',
  MATCH_SPLAT = '/*',
}

export type AllType = RoutePath.DEVICE | RoutePath.GROUP | RoutePath.TYPE;

export function isAllType(path): path is AllType {
  switch (path) {
    case RoutePath.DEVICE:
    case RoutePath.GROUP:
    case RoutePath.TYPE:
      return true;
    default:
      return false;
  }
}

/**
 * Checks if HW types or devices in tree
 * @param allType
 * @returns true for tree of devices or groups
 */
export function isDevicesTree(allType: AllType) {
  return allType === RoutePath.DEVICE || allType === RoutePath.GROUP;
}

const findDuplicates = (arr: string[]) => arr.filter((item, index) => arr.indexOf(item) != index);
const duplicates = findDuplicates(Object.values(RoutePath));
if (duplicates.length > 0) throw new Error('Routes are not unique: ' + duplicates);
